import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../molecules/RoundedModal'
import CreateComponentBlueprintForm from './form'

const CreateComponentBlueprintDialog = React.forwardRef(function CreateComponentBlueprintDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogState({ open: true, processing: false })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Create Component Blueprint'
      open={dialogState.open}
      onClose={close}
      size='large'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <CreateComponentBlueprintForm
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

CreateComponentBlueprintDialog.propTypes = {
  onComplete: PropTypes.func
}

CreateComponentBlueprintDialog.defaultProps = {
  onComplete: () => {}
}

export default CreateComponentBlueprintDialog
